(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/components/desktop-content-constrain.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/components/desktop-content-constrain.js');

'use strict';

const DesktopContentConstrain = _ref => {
  let children = _ref.children;
  return React.createElement("div", {
    className: "main-content-constrained"
  }, children);
};
svs.playerRegistration.components.DesktopContentConstrain = DesktopContentConstrain;

 })(window);